import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const ListingRevampLayout = styled.div`
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: ${theme.lightGreyBG};
  position: relative;
  z-index: 2;
`;

export const ContentWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.greyText8};
  z-index: 10;
`;
